import { Fragment, useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { useForm, useFieldArray, Controller } from 'react-hook-form'
import { DefaultConfig } from '../../settings/config'
import { useParams, useNavigate } from 'react-router-dom'
import * as yup from "yup"
import { GetCompanyDetailsById, UpateCompany, UpdateUserAddress, CreateCompanyUserMapping, UpdateUserCompanyMappingById, GetUserByEmail } from '../redux/store'
import classnames from 'classnames'
import { yupResolver } from "@hookform/resolvers/yup"
import { isObjEmpty, selectThemeColors } from '@utils'
import Select from 'react-select'
import { Row, Col, Button, Label, Input, Form, FormFeedback, Spinner, Modal, ModalHeader, ModalBody, ModalFooter, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Table, Accordion, AccordionBody, AccordionHeader, AccordionItem, UncontrolledTooltip } from 'reactstrap'
import { Edit, Plus, Trash2, RefreshCcw, ChevronUp, ChevronDown, X, Calendar } from "react-feather"
import CustomValueContainer from "../Components/Select"
import ComponentSpinner from '../../components/spinner/Loading-spinner'
import Sidebar from '../Components/SideBar'
import toast from 'react-hot-toast'
import ToastMessage from '../../components/toast-messages'
import { isUserLoggedIn } from "../../@core/auth/utils"
import MultiSelect from './MultiSelectFRP'
import CustomValueContainer1 from "../Components/ToolTipSelect"
import '@styles/react/libs/flatpickr/flatpickr.scss'
import Flatpickr from 'react-flatpickr'
import SourceSystemCustomContainer from '../Components/CustomSelect'

const ActiveCompany = () => {
  const loggedinUserDetails = isUserLoggedIn() && JSON.parse(isUserLoggedIn())
  const dispatch = useDispatch()
  const stores = useSelector((state) => state.commonreducerSlice)
  const [stateOptions, setStateOptions] = useState([])
  const selectStyles = DefaultConfig().selectStyles

  const [companySFUniqueId, setCompanySFUniqueId] = useState("")
  const [companyName, setCompanyName] = useState("")
  const [companyAgentId, setCompanyAgentId] = useState("")
  const DepartmentMapping = DefaultConfig().DepartmentMapping
  // const SourceSystem=DefaultConfig().SourceSystem
  const showImportCompBtn = DefaultConfig().ShownImportCompanyBtn

  const { id } = useParams()
  const [spinnerStatus, setSpinnerStatus] = useState(false)
  const [mspinnerStatus, setMSpinnerStatus] = useState(false)
  const [spinnerUStatus, setUSpinnerStatus] = useState(true)
  const [companyIdData, setCompanyIdData] = useState(null)
  const sorter = DefaultConfig().sorter
  const [isEdited, setIsEdited] = useState(false)
  const [backupData, setBackupData] = useState([])
  const [errorMessage, setErrorMessage] = useState([])
  const [statusOption, setStatus] = useState(null)
  const [statusesOptions, setStatusesOptions] = useState(null)
  const [spinnerArray, setSpinnerArray] = useState([])
  const [disabling, setDisabling] = useState(false)
  const [disableSpinner, setDisableSpinner] = useState(false)
  const [modalSpinnerStatus, setMOdalSpinnerStatus] = useState(false)
  const [endDate, setEndDate] = useState(null)
  const fpRef = useRef(null)

  const statusOptions = [
    { value: 'All', label: 'All', id: 3 },
    { value: 'Active', label: 'Active', id: 1 },
    { value: 'InActive', label: 'InActive', id: 2 }

  ]
  const [userStatus, setUserStatus] = useState(statusOptions[0])
  const regionalOffices = DefaultConfig().regionalOffices
  const SourceSystem = DefaultConfig().SourceSystem
  const formattedDateIssueFixed = DefaultConfig().formattedDateIssueFixed
  const [addressStatus, setAddressStatus] = useState(true)
  const [loadingUserId, setLoadingUserId] = useState(null)
  const [regionalOption, setRegionalOption] = useState([])
  const navigate = useNavigate()
  const options = [
    { value: 'Active', label: 'Active', id: 1 },
    { value: 'InActive', label: 'InActive', id: 2 },
    { value: 'Suspended', label: 'Suspended', id: 3 }
  ]

  const [newFirstName, setNewFirstName] = useState("")
  const [newLastName, setNewLastName] = useState("")
  const [newEmail, setNewEmail] = useState("")

  // const useraddressArray = ["Primary Address", "Shipping Address", "Billing Address"]
  const optionAdrress = [{ value: "Primary Address", label: "Primary Address", id: 1 }, { value: "Shipping Address", label: "Shipping Address", id: 2 }, { value: "Billing Address", label: "Billing Address", id: 3 }]
  const [addressOption, setAddressOption] = useState(null)
  const [show, setShow] = useState(false)
  const [department, setDepartment] = useState("")
  const [sourceSystem, setSourceSystem] = useState(null)

  const [filterFirstName, setFilterFirstName] = useState('')
  const [filterLastName, setFilterLastName] = useState('')
  const [filterEmail, setFilterEmail] = useState('')
  const [modal, setModal] = useState(false)
  const [infoModal, setInfoModal] = useState(false)
  const [actionModal, setActionModal] = useState(false)
  const [actionIndex, setActionIndex] = useState(null)
  const [filterSourceSystemId, setFilterSourceSystemId] = useState('')
  const [filterUserList, setFilterUserList] = useState([])
  //  const [companyDetailsDisabling, setCompanyDetailsDisabling] = useState(false)
  //sorting
  const [sortConfig, setSortConfig] = useState({ key: 'userFirstName', direction: 'asc' })

  const filteredUsers = companyIdData?.companyUsers?.filter(company => {
    return (
      (!filterFirstName || company.userFirstName.toLowerCase().includes(filterFirstName.toLowerCase())) &&
      (!filterLastName || company.userLastName.toLowerCase().includes(filterLastName.toLowerCase())) &&
      (!filterEmail || company.userEmail.toLowerCase().includes(filterEmail.toLowerCase())) &&
      (!filterSourceSystemId || company.sourceSystemId === filterSourceSystemId?.id)
    )
  }) ?? []

  const sortedUsers = [...filteredUsers].sort((a, b) => {
    const aValue = a[sortConfig.key] ?? ''
    const bValue = b[sortConfig.key] ?? ''

    if (typeof aValue === 'string' && typeof bValue === 'string') {
      return sortConfig.direction === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue)
    }

    // For numbers or other types, direct comparison
    if (aValue < bValue) {
      return sortConfig.direction === 'asc' ? -1 : 1
    }
    if (aValue > bValue) {
      return sortConfig.direction === 'asc' ? 1 : -1
    }
    return 0
  })

  const requestSort = (key) => {
    let direction = 'asc'
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    setSortConfig({ key, direction })
  }


  const ValidSchema = yup.object().shape({
    [`newFirstName`]: yup.string().nullable().notRequired("First Name is a required field"),
    [`newLastName`]: yup.string().nullable().notRequired("Last Name is a required field"),
    [`newEmail`]: yup.string().trim().nullable().notRequired("Email is a required field").email("Email is invalid"),
    [`sourceSystem`]: yup.object().nullable().notRequired("Source System is a required field")
  })

  const { trigger, handleSubmit, control, reset, setValue, formState: { errors } } = useForm({ mode: 'onChange', resolver: yupResolver(ValidSchema) })
  const [AgentValidateError, setAgentValidateError] = useState('')
  const handleReset = () => {
    reset({
      newFirstName: null,
      newLastName: null,
      newEmail: null,
      sourceSystem: null
    })
    setNewEmail("")
    setValue("newEmail", "")
    setNewFirstName("")
    setValue("newFirstName", "")
    setValue("newLastName", "")
    setNewLastName("")
    setSourceSystem(null)
    setValue("sourceSystem", null)
    setDisabling(false)
    setEndDate(null)
    setFilterUserList([])
    setAgentValidateError('')
  }

  function getCountry(data) {
    const country = stores?.countryStates.find((item) => item.id === data)
    if (country) {
      return country
    } else {
      return ""
    }
  }

  function countryValues(obj, data) {
    const country = stores?.countryStates.find((item) => item.id === obj.countryId)
    if (!country) return null
    if (data === "country") {
      return country
    } else {
      const states = country.states || []
      const matchingState = states.find((item) => item.name === data)
      if (matchingState) {
        return {
          ...matchingState,
          label: matchingState.name,
          value: matchingState.name
        }
      } else {
        return { value: data, label: data }
      }
    }
  }

  const addCountryNames = (user) => {
    return [
      ...user.map(address => ({
        ...address,
        companyAddress: {
          ...address.companyAddress,
          countryName: countryValues(address.companyAddress, "country"),
          state: countryValues(address.companyAddress, address.companyAddress.state),
          isEdit: true
        }
      }))
    ]
  }

  function MappingFunction(data) {
    if (data) {
      if (Object.keys(data).length) {
        setBackupData(addCountryNames(data.companyAddresses))
        setErrorMessage(Array(data.companyAddresses.length).fill({ address1: '', address2: "", city: "", state: "", country: "" }))
      }

    }

    setSpinnerStatus(false)
  }

  const getNdaData = (data) => {
    const companyIdData = { ...data }
    if (companyIdData) {
      setCompanyIdData(companyIdData)
      if (companyIdData?.companyStatus) {
        const temp = options.find((item) => item.id === companyIdData?.companyStatus)
        setStatus(temp)
      }
      if (companyIdData?.regionalOfficeIds?.length) {
        setRegionalOption(companyIdData?.regionalOfficeIds?.map((entry) => regionalOffices.find((item) => item.id === entry)))
      } else {
        setRegionalOption([])
      }
      setAddressOption(optionAdrress[0])
      setCompanyName(companyIdData.companyName ? companyIdData.companyName : companyName)
      setValue('companyName', companyIdData.companyName ? companyIdData.companyName : '')

      setCompanyAgentId(companyIdData.companyAgentId ? companyIdData.companyAgentId : companyAgentId)
      setValue('companyAgentId', companyIdData.companyAgentId ? companyIdData.companyAgentId : '')

      setCompanySFUniqueId(companyIdData.companySFUniqueId ? companyIdData.companySFUniqueId : companySFUniqueId)
      setValue('companySFUniqueId', companyIdData.companySFUniqueId ? companyIdData.companySFUniqueId : '')

      setDepartment(companyIdData.companyGPClientDepartmentId ? DepartmentMapping(companyIdData.companyGPClientDepartmentId) : "")
      setValue('department', companyIdData.companyGPClientDepartmentId ? DepartmentMapping(companyIdData.companyGPClientDepartmentId) : "")
    }
  }

  useEffect(() => {
    const backupDataSpinner = Array(backupData.length).fill(false)
    setSpinnerArray(backupDataSpinner)
  }, [backupData.length])

  // useEffect(() => {
  //     if (stores?.countryStates.length && Object.keys(stores?.companyDetailswithId).length) {
  //         MappingFunction(stores?.companyDetailswithId)
  //         getNdaData()
  //     }
  // }, [stores?.countryStates, stores?.companyDetailswithId])

  async function fetch(value1, value2) {
    const obj = {}
    obj.id = Number(id)
    obj.isAddressMapping = value2
    if (value1 !== 3) {
      obj.isUserMapping = value1 === 1 ? true : value1 === 2 ? false : ""
    }
    setSpinnerStatus(true)
    const response = await dispatch(GetCompanyDetailsById(obj)).finally(() => { })
    if (response.payload) {
      if (true) {
        MappingFunction(response.payload.data)
        getNdaData(response.payload.data)
      }
    } else {
      setSpinnerStatus(false)
    }
  }

  useEffect(() => {
    fetch(userStatus?.id, addressStatus)
  }, [Number(id)])

  const onSubmit = async () => {
    trigger()
    if (Object.keys(errors).length === 0) {
      let hasUserError = false

      // Deep clone to avoid mutating original array
      const updatedUsers = [...filterUserList].map((user, index) => {
        let errorMsg = ""

        if (!user.firstName?.trim()) {
          errorMsg += "First name is missing. "
        }
        if (!user.lastName?.trim()) {
          errorMsg += "Last name is missing. "
        }
        if (!user.classId || user.classId.length === 0) {
          errorMsg += "Please select atleast one source system. "
        }

        if (errorMsg) {
          hasUserError = true
          return { ...user, errorMessage: errorMsg.trim() }
        }

        return { ...user, errorMessage: "" }
      })

      // Update list state to show inline error messages
      setFilterUserList(updatedUsers)

      // Stop submission if any error exists
      if (hasUserError) {
        return
      }
      const obj = {}
      obj.companyId = id
      const filteredUsers = [...filterUserList]
      obj.userIds = filteredUsers.map(element => ({
          userEmail: element.email, 
          firstName: element.firstName, 
          lastName: element.lastName,
          sourceSystems: [...new Set(element.classId)].map(cls => ({ sourceSystemId: cls, endDate: (element?.endDates?.find(find => find.id === cls) ? element?.endDates?.find(find => find.id === cls)?.endDate : null) }))
        }))
      async function fetch1() {
        setMSpinnerStatus(true)
        const response = await dispatch(CreateCompanyUserMapping(obj)).finally(() => {
          setMSpinnerStatus(false)
        })
        if (response.payload) {
          fetch(userStatus.id, addressStatus)
          setShow(false)
          reset()
          setEndDate(null)
        }
      }
      fetch1()
    }
  }

  // const handleCheckboxChange = () => {
  //     setUserStatus(!userStatus)
  //     fetch(!userStatus, addressStatus)
  // }

  function comparingRegionalIds(prevoiusData, presentData) {
    const presentDatalist = presentData?.map((item) => item.id)
    if (prevoiusData?.length !== presentDatalist?.length) {
      if (prevoiusData) {
        return true
      } else {
        return false
      }
    } else {
      return (prevoiusData?.map((item) => presentDatalist.includes(item)).includes(false))
    }

  }
  function Inputvalidation(updatedData, index, attributeName, countryContain) {
    const newErrorMessage = [...errorMessage]
    const error = {}
    for (let i = 0; i < updatedData.length; i++) {
      if (index === i) {
        if ((updatedData[i]["companyAddress"][attributeName] === '') || (updatedData[i]["companyAddress"][attributeName] === null)) {
          if (attributeName === "address1") {
            error["address1"] = "Address1 is a Required Field"
            error["address2"] = newErrorMessage[index]["address2"]
            error["city"] = newErrorMessage[index]["city"]
            error["state"] = newErrorMessage[index]["state"]
            error["country"] = newErrorMessage[index]["country"]
          } else if (attributeName === "address2") {
            error["address2"] = "Address2 is a Required Field"
            error["address1"] = newErrorMessage[index]["address1"]
            error["city"] = newErrorMessage[index]["city"]
            error["state"] = newErrorMessage[index]["state"]
            error["country"] = newErrorMessage[index]["country"]
          } else if (attributeName === "city") {
            error["city"] = "city is a Required Field"
            error["address2"] = newErrorMessage[index]["address2"]
            error["address1"] = newErrorMessage[index]["address1"]
            error["state"] = newErrorMessage[index]["state"]
            error["country"] = newErrorMessage[index]["country"]
          } else if (attributeName === "countryName") {
            error["country"] = newErrorMessage[index][""]
            error["state"] = ""
            error["address1"] = newErrorMessage[index]["address1"]
            error["address2"] = newErrorMessage[index]["address2"]
            error['city'] = newErrorMessage[index]["city"]
          } else if (attributeName === "state") {
            error["country"] = newErrorMessage[index]['country']
            if (updatedData[i]["companyAddresses"]["countryName"].states.length) {
              error["state"] = "state is a Required Field"
            }
            error["address1"] = newErrorMessage[index]["address1"]
            error["address2"] = newErrorMessage[index]["address2"]
            error['city'] = newErrorMessage[index]["city"]
            error["country"] = newErrorMessage[index]["country"]
          }

        } else {
          if (attributeName === "address1") {
            error["adress1"] = ""
            error["address2"] = newErrorMessage[index]["address2"]
            error["city"] = newErrorMessage[index]["city"]
            error["country"] = newErrorMessage[index]["country"]
            error["state"] = newErrorMessage[index]["state"]
          } else if (attributeName === "address2") {
            error["address2"] = ""
            error["address1"] = newErrorMessage[index]["address1"]
            error["city"] = newErrorMessage[index]["city"]
            error["state"] = newErrorMessage[index]["state"]
            error["country"] = newErrorMessage[index]["country"]
          } else if (attributeName === "city") {
            error["city"] = ""
            error["address2"] = newErrorMessage[index]["address2"]
            error["address1"] = newErrorMessage[index]["address1"]
            error['country'] = newErrorMessage[index]["country"]
            error["state"] = newErrorMessage[index]["state"]
          } else if (attributeName === "countryName") {
            error["country"] = ""
            error["state"] = ""
            error["city"] = newErrorMessage[index]["city"]
            error["address1"] = newErrorMessage[index]["address1"]
            error['address2'] = newErrorMessage[index]["address2"]
          } else if (attributeName === "state") {
            if (countryContain) {
              error["state"] = ""
            } else {
              error["state"] = newErrorMessage[index]["state"]
            }
            error['country'] = newErrorMessage[index]["country"]
            error["city"] = newErrorMessage[index]["city"]
            error["address1"] = newErrorMessage[index]["address1"]
            error['address2'] = newErrorMessage[index]["address2"]
          }
        }
        newErrorMessage[index] = error
      }
    }
    setErrorMessage(newErrorMessage)
  }

  const onChangeInput = (e, index, attributeName) => {
    let updateData = []
    const companyAddresses = [...backupData]
    if (e !== null) {
      if (attributeName === "state" && Object.keys(e)?.includes("label")) {
        updateData = companyAddresses.map((item, i) => {
          if (index === i) {
            return {
              ...item,
              companyAddress: {
                ...item.companyAddress,
                state: e
              }
            }
          } else {
            return { ...item }
          }
        })
      }
      if (attributeName === "state" && !Object.keys(e)?.includes("label")) {

        updateData = companyAddresses.map((item, i) => {
          if (index === i) {
            return {
              ...item,
              companyAddress: {
                ...item.companyAddress,
                state: e?.target?.value
              }
            }
          } else {
            return { ...item }
          }
        })
      }
    }

    if (attributeName === "state" && e === null) {

      updateData = companyAddresses.map((item, i) => {
        if (index === i) {
          return {
            ...item,
            companyAddress: {
              ...item.companyAddress,
              state: null
            }
          }
        } else {
          return { ...item }
        }
      })
    }

    if (attributeName === "countryName") {
      updateData = companyAddresses.map((item, i) => {
        if (index === i) {
          return {
            ...item,
            companyAddress: {
              ...item.companyAddress,
              countryName: e,
              state: e?.states?.length ? null : ""
            }
          }
        } else {
          return { ...item }
        }
      })
    }
    if (attributeName === "address1" || attributeName === "city" || attributeName === "address2") {
      const { value } = e.target
      updateData = companyAddresses.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            companyAddress: {
              ...item.companyAddress,
              [attributeName]: value
            }

          }
        }
        return item
      })
    }
    setBackupData(updateData)

    Inputvalidation(updateData, index, attributeName, attributeName === "state" ? e === null ? true : Object.keys(e)?.includes("label") : "")

  }

  async function userUpdateFunction() {

    setUSpinnerStatus(false)
    const obj = {}
    obj["id"] = Number(id)
    obj["name"] = companyName
    obj["agentId"] = String(companyAgentId)
    if (companySFUniqueId) {
      obj["sfUniqueId"] = companySFUniqueId
    }
    if (statusOption.id) {
      obj["status"] = statusOption.id
    }
    if (companyIdData.companyGPClientDepartmentId) {
      obj["clientDepartmentId"] = companyIdData.companyGPClientDepartmentId
    }
    if (regionalOption) {
      obj["regionalOfficeIds"] = regionalOption.map((item) => item.id)
    }
    obj.lastModifiedBy = loggedinUserDetails?.userRoles[0]?.userId
    const response = await dispatch(UpateCompany(obj)).finally(() => {
      setUSpinnerStatus(true)
      setIsEdited(false)
    })
    if (response.payload) {
      fetch(userStatus.id, addressStatus)
    }
  }

  function updateEdit(index) {
    const companyAddresses = [...backupData]
    const updateData = companyAddresses.map((item, i) => {
      if (index === i) {
        return {
          ...item,
          companyAddresses: {
            ...item.companyAddress,
            isEdit: (!item.companyAddress.isEdit)
          }
        }
      } else {
        return { ...item }
      }
    })
    setBackupData(updateData)
  }

  function validateData(index) {
    const checkingValue = backupData[index]

    const newErrorMessage = [...errorMessage]
    let condition = false
    const error = {}
    if (checkingValue) {
      if (!checkingValue.companyAddress.city.length) {
        error["city"] = "city is Required Field"
        condition = true
      } else {
        error["city"] = ""
      }
      if (!checkingValue.companyAddress.address1.length) {
        error["address1"] = "city is Required Field"
        condition = true
      } else {
        error["address1"] = ""
      }
      if (checkingValue?.companyAddress?.
        countryName) {
        error["country"] = ""
      } else {
        error["country"] = "country is Required Field"
        condition = true
      }
      if (checkingValue?.companyAddress?.countryName?.states?.length && checkingValue?.companyAddress.state !== null) {
        error["state"] = ""
      } else if (checkingValue?.companyAddress?.countryName?.states?.length && checkingValue?.companyAddress.state === null) {
        error["state"] = "state is Required Field"
        condition = true
      } else if (!checkingValue?.companyAddress?.countryName?.states?.length) {
        error["state"] = ""
      }
    }

    newErrorMessage[index] = error
    setErrorMessage(newErrorMessage)
    return condition
  }

  async function updateAddressFunction(index) {
    const isEmpty = validateData(index)
    if (!isEmpty) {
      const payloadData = backupData[index]
      const obj = {}
      obj.id = payloadData.userAddressId
      obj.addressTypeId = payloadData.companyAddress.addressTypeId
      obj.address1 = payloadData.companyAddress.address1
      obj.address2 = payloadData.companyAddress.address2
      obj.countryId = payloadData.companyAddress.countryName.id
      if (typeof (payloadData.companyAddress.state) === "string") {
        obj.state = payloadData.companyAddress.state
      } else {
        obj.state = payloadData.companyAddress.state.label
      }
      obj.city = payloadData.companyAddress.city
      const spinnerValues = [...spinnerArray]
      spinnerValues[index] = !spinnerValues[index]
      setSpinnerArray(spinnerValues)

      const response = await dispatch(UpdateUserAddress(obj)).finally(() => {
        const spinnerValues = [...spinnerArray]
        spinnerValues[index] = !spinnerValues[index]
        setSpinnerArray(spinnerValues)

      })
      if (response.payload) {
        fetch(userStatus.id, addressStatus)
      }
    }
  }

  const toggleSidebar = () => {
    handleReset()
    setShow(false)
  }

  const MakeInActive = async (value1, value2, sourceSystemId, passedEmail) => {
    setLoadingUserId(value1)
    const obj = {}
    obj.companyId = Number(id)
    obj.userId = value1
    obj.isActive = !value2
    obj.sourceSystemId = sourceSystemId
    obj.userEmail = passedEmail
    obj.lastModifiedBy = loggedinUserDetails?.userRoles[0]?.userId
    const response = await dispatch(UpdateUserCompanyMappingById(obj)).finally(() => {
      setLoadingUserId(null)
    })
    if (response.payload) {
      fetch(userStatus?.id, addressStatus)
    }
  }

  function cancel() {
    const temp = options.find((item) => item?.id === companyIdData?.companyStatus)
    setStatus(temp)
    // console.log(companyIdData?.regionalOfficeId, 'companyIdData?.regionalOfficeId')
    // if (companyIdData?.regionalOfficeId) {
    //   setRegionalOption(regionalOffices.find((item) => item.id === companyIdData?.regionalOfficeId))
    // } else {
    //   setRegionalOption(regionalOffices)
    // }
    // setCompanyDetailsDisabling(false)
  }

  const [courseArray, setCourseArray] = useState([])
    const toggle = id => {
      const coursesArr = [...courseArray]
      if (coursesArr.find(find => find === id)) {
        coursesArr.splice(coursesArr.findIndex(find => find === id), 1)
      } else {
        coursesArr.push(id)
      }
      setCourseArray(coursesArr)
    }
  
    useEffect(() => {
      if (filterUserList?.length > 0) {
        const generateArray = (length) => Array.from({ length }, (_, i) => (i + 1).toString())
        setCourseArray(generateArray(filterUserList?.length))
      }
    }, [filterUserList?.length])

    const fpRefs = useRef({})
    
    const makeKey = (agentId, id) => `${agentId}_${id}`

    const handleSourceSystemChange = (index, selectedOptions) => {
      const updatedList = filterUserList.map((agent, i) => {
      // const isValidSourceSystem = selectedOptions && selectedOptions.length > 0
      // setIsSourceSystemSelected(isValidSourceSystem)
      if (i === index) {
        return {
          ...agent,
          classId: Array.isArray(selectedOptions) ? selectedOptions.map((option) => option.id) : []
        }
      }
      return agent
    })
    // Deep clone to avoid mutating original array
    const updatedUsers = [...updatedList].map((user, index) => {
      let errorMsg = ""

      if (!user.firstName?.trim()) {
        errorMsg += "First name is missing. "
      }
      if (!user.lastName?.trim()) {
        errorMsg += "Last name is missing. "
      }
      if (!user.classId || user.classId.length === 0) {
        errorMsg += "Please select atleast one source system. "
      }

      if (errorMsg) {
        return { ...user, errorMessage: errorMsg.trim() }
      }

      return { ...user, errorMessage: "" }
    })
    setFilterUserList(updatedUsers)
    const currentAgent = updatedList[index]
    const existingData = companyIdData?.companyUsers?.filter((item) => (item.userEmail) === (currentAgent.email) && Array.isArray(currentAgent.classId) && currentAgent.classId.includes(item.sourceSystemId))
    const filterArray = updatedList.filter((item) => Array.isArray(item.classId) && item.classId.some((id) => currentAgent.classId.includes(id)) && (item.email) === (currentAgent.email))
    if (existingData.length > 0) {
      setAgentValidateError(`User(${currentAgent.email}) with same Source System (${existingData.map(item => SourceSystem(item.sourceSystemId)?.label).join(', ')}) already exists.`)
      // setDisableAgentInput(true)
      // setDisIndex(index)
    } else if (filterArray.length > 1) {
      setAgentValidateError(`User(${currentAgent.email}) with same Source System (${currentAgent.classId.map(id => SourceSystem(id)?.label).join(', ')}) already selected.`)
      // setDisableAgentInput(true)
      // setDisIndex(index)
    } else {
      if (AgentValidateError.includes(currentAgent?.email) === false) {

      } else {
        setAgentValidateError('')
        // setDisableAgentInput(false)
        // setDisIndex("notRequired")
      }

    }
      // const selectedIds = Array.isArray(selectedOptions) ? selectedOptions.map(option => option.id) : []

      // // Clone current list
      // const updatedList = [...filterUserList]

      // const currentAgent = updatedList[index]
      // const currentEmail = currentAgent.email

      // // 🔹 Find existing records from backend for this user + classId
      // const existingData = companyIdData?.companyUsers?.filter(item => item.userEmail === currentEmail && selectedIds.includes(item.sourceSystemId)) || []

      // // 🔹 Remove source systems that already exist
      // const duplicateIds = existingData.map(item => item.sourceSystemId)
      // const filteredIds = selectedIds.filter(id => !duplicateIds.includes(id))

      // // 🔹 Toast for duplicates (if any)
      // if (duplicateIds.length > 0) {
      //   toast(t => (
      //     <ToastMessage
      //       t={t}
      //       message={`User (${currentEmail}) already exists with Source System(s): ${duplicateIds
      //         .map(id => SourceSystem(id)?.label)
      //         .join(', ')}`}
      //       status="danger"
      //     />
      //   ))
      // }

      // // 🔹 Update agent list
      // updatedList[index] = {
      //   ...currentAgent,
      //   classId: filteredIds
      // }

      // // 🔹 Check for duplicates within current selection too
      // const duplicateSelections = updatedList.filter((item, i) => i !== index && item.email === currentEmail && item.classId.some(id => filteredIds.includes(id)))

      // if (duplicateSelections.length > 0) {
      //   toast(t => (
      //     <ToastMessage
      //       t={t}
      //       message={`User (${currentEmail}) already selected with same Source System(s): ${filteredIds
      //         .map(id => SourceSystem(id)?.label)
      //         .join(', ')}`}
      //       status="danger"
      //     />
      //   ))

      //   // Remove local duplicates too
      //   updatedList[index].classId = updatedList[index].classId.filter(id => !duplicateSelections.some(sel => sel.classId.includes(id)))
      // }

      // setFilterUserList(updatedList)
  }

  const handleSourceSystemDelete = (index, id) => {
    // const updatedList = [...filterUserList]
    // updatedList[index].classId = updatedList[index].classId.filter((classId) => classId !== id)
    // setFilterUserList(updatedList)

    const updatedList = [...filterUserList]
    updatedList[index].classId = updatedList[index].classId.filter((classId) => classId !== id)
    setFilterUserList(updatedList)
    const currentAgent = updatedList[index]
    const existingData = companyIdData?.companyUsers?.filter((item) => {
      return (
        (item.userEmail) === (currentAgent.email) &&
        Array.isArray(currentAgent.classId) &&
        currentAgent.classId.includes(item.sourceSystemId)
      )
    })
    const filterArray = updatedList.filter((item) => {
      return (
        Array.isArray(item.classId) &&
        item.classId.some((id) => currentAgent.classId.includes(id)) &&
        (item.email) === (currentAgent.email)
      )
    })
    if (existingData.length > 0) {
      setAgentValidateError(`User(${currentAgent.agentId}) with same Source System (${existingData.map(item => SourceSystem(item.sourceSystemId)?.label).join(', ')}) already exists.`)
      // setDisableAgentInput(true)
      // setDisIndex(index)
    } else if (filterArray.length > 1) {
      setAgentValidateError(`User(${currentAgent.agentId}) with same Source System (${currentAgent.classId.map(id => SourceSystem(id)?.label).join(', ')}) already selected.`)
      // setDisableAgentInput(true)
      // setDisIndex(index)
    } else {
      setAgentValidateError('')
      // setDisIndex("notRequired")
      // setDisableAgentInput(false)
    }
  }

  const NoOptionsMessage = (props) => {
      return (
        <components.NoOptionsMessage {...props}>
          {addCompanyOption ? (
            <Fragment>
              No Options
            </Fragment>
          ) : (
            <div>Enter min 3 characters.</div>
          )}
        </components.NoOptionsMessage>
      )
    }

  return (
    !spinnerStatus ? (<div>

      <Row className="card_style pt-2 pb-2" style={{ margin: "0px 0px" }}>
        <Sidebar
          size="sm"
          open={show}
          title={`Add User Details`}
          headerClassName="mb-1"
          contentClassName="pt-0"
          toggleSidebar={toggleSidebar}
        >
          {(show) ? (<>
            <Form onSubmit={handleSubmit(onSubmit)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                }
              }}
              style={{ margin: '5px' }}>
              <ModalBody style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '0px' }}>
                <Row>
                  <Col sm='12' md='12' lg='12' xl='12'>
                    <div className='input-wrapper'>
                      <Controller
                        defaultValue=''
                        control={control}
                        id='newEmail'
                        name='newEmail'
                        render={({ field: { onChange, onBlur } }) => <Input
                          placeholder=''
                          invalid={errors.newEmail && true}
                          value={newEmail}
                          onChange={(val) => {
                            if (val.target.value) {
                              // delete errors.newFirstName
                              // delete errors.newLastName
                              // delete errors.sourceSystem
                            }
                            if (val.target.value === "") {
                              // setValue("newFirstName", "")
                              // setValue("newLastName", "")
                              // setNewLastName("")
                              // setNewFirstName("")
                              setDisabling(false)
                            }
                            onChange(val, setNewEmail(val.target.value))
                          }}
                          onBlur={async () => {
                            onBlur()
                            if (!errors.newEmail && newEmail) {
                              try {
                                setDisableSpinner(true)
                                const response = await dispatch(GetUserByEmail({ email: newEmail }))
                                if (response?.payload) {
                                  const filteredUsers = [...filterUserList]
                                  if (filteredUsers.find(find => find.email === newEmail)) {
                                    toast(t => (<ToastMessage t={t} message={"User already added"} status={"danger"} />))
                                  } else {
                                    filteredUsers.push({ email: newEmail, firstName: response?.payload?.data.firstName, lastName: response?.payload?.data.lastName, classId: [] })
                                    setFilterUserList(filteredUsers)
                                    // setValue("newFirstName", response?.payload?.data.firstName)
                                    // setNewFirstName(response?.payload?.data.firstName)
                                    // setValue("newLastName", response?.payload?.data.lastName)
                                    // setNewLastName(response?.payload?.data.lastName)
                                    // delete errors.newFirstName
                                    // delete errors.newLastName
                                    // delete errors.sourceSystem
                                    toast(t => (<ToastMessage t={t} message={" User Data Found"} status={"success"} />))
                                  }
                                  setNewEmail('')
                                  setDisabling(true)
                                  setDisableSpinner(false)
                                } else {
                                  setNewEmail('')
                                  setDisableSpinner(false)
                                  setDisabling(true)
                                  // setValue("newFirstName", "")
                                  // setNewFirstName("")
                                  // setValue("newLastName", "")
                                  // setNewLastName("")
                                  // delete errors.newFirstName
                                  // delete errors.newLastName
                                  // delete errors.sourceSystem
                                  toast(t => (<ToastMessage t={t} message={"User Data not Found"} status={"success"} />))
                                }

                              } catch (error) {
                                console.error('API call failed:', error)
                              }
                            }
                          }}
                        />}
                      />
                      <Label className='form-label' for={`newEmail`}>
                        Email
                      </Label>
                      {errors.newEmail && <FormFeedback>{errors.newEmail.message}</FormFeedback>}
                    </div>
                  </Col>
                </Row>
                {
                  !disableSpinner ? <> 
                  {disabling && 
                  <Row>
                    <Col>
                      <div className='listAgents'>
                        {filterUserList.map((item, index) => {
                          const agentAlreadySelected = filterUserList.some((agent) => agent.email === item.email)
                          const indexValue = String(index + 1)
                          const preExistingData = companyIdData?.companyUsers.filter((find) => find.userEmail === item.email && item.classId.includes(find.sourceSystemId))
                          return (
                          <div className='mt-1'>
                            <Accordion className='accordion-border' open={courseArray.find(find => find === indexValue) ? courseArray.find(find => find === indexValue) : ''} toggle={toggle} style={{ marginBottom: '15px' }}>
                              <AccordionItem open={courseArray.find(find => find === indexValue) ? courseArray.find(find => find === indexValue) : ''}>
                                <AccordionHeader targetId={indexValue} className={'accordian-head acc-item'}>
                                  <div className='d-flex w-100'>
                                    <div style={{ width: '95%', fontSize: '16px', marginLeft: '10px', marginTop: courseArray.find(find => find === indexValue) ? '3px' : '0px', color: (item?.errorMessage || preExistingData.length > 0) ? 'red' : '#00ADC3'}}>
                                      {item?.email}
                                    </div>
                                    <div>|</div>
                                    <div className='text-right' id={`clear_${index + 1}`}>
                                      <span
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          const filteredUsers = [...filterUserList]
                                          filteredUsers.splice(index, 1)
                                          setFilterUserList(filteredUsers)
                                        }}
                                        className='cross_mark'
                                        style={{ fontWeight: "900", cursor: "pointer", float: 'right', fontSize: '14px', marginTop: '2px' }}
                                      > X </span>
                                    </div>
                                    <UncontrolledTooltip placement='bottom' target={`clear_${index + 1}`}>Remove</UncontrolledTooltip>
                                  </div>
                                </AccordionHeader>
                                <AccordionBody accordionId={indexValue}>
                                  {item?.errorMessage &&
                                   <Row>
                                    <Col sm='12' md='12' lg='12' xl='12'>
                                      <div className='mt-2' style={{ fontSize: '15px', color: 'red', fontWeight: 500 }}>
                                        {item?.errorMessage}
                                      </div>
                                    </Col>
                                  </Row>
                                  }
                                  <Row>
                                    <Col sm='12' md='12' lg='12' xl='12'>
                                    <div className='mt-2 input-wrapper'>
                                      <Controller
                                        defaultValue=''
                                        control={control}
                                        id='newFirstName'
                                        name='newFirstName'
                                        render={({ field: { onChange } }) => <Input
                                          placeholder=''
                                          invalid={errors.newFirstName && true}
                                          value={item.firstName}
                                          disabled
                                          onChange={(val) => {
                                            onChange(val, setNewFirstName(val.target.value))
                                            const filteredUsers = [...filterUserList]
                                            const findItem = {...filteredUsers[index]}
                                            findItem['firstName'] = val.target.value
                                            filteredUsers[index] = findItem
                                            setFilterUserList(filteredUsers)
                                          }}
                                        />}
                                      />
                                      <Label className='form-label' for={`newFirstName`}>
                                        First Name
                                      </Label>
                                      {errors.newFirstName && <FormFeedback>{errors.newFirstName.message}</FormFeedback>}
                                    </div>
                                    </Col>
                                    </Row>
                                    <Row>
                                      <Col sm='12' md='12' lg='12' xl='12'>
                                        <div className='mt-2 input-wrapper'>
                                          <Controller
                                            defaultValue=''
                                            control={control}
                                            id='newLastName'
                                            name='newLastName'
                                            render={({ field: { onChange } }) => <Input
                                              placeholder=''
                                              invalid={errors.newLastName && true}
                                              value={item.lastName}
                                              disabled
                                              onChange={(val) => {
                                                onChange(val, setNewLastName(val.target.value))
                                                const filteredUsers = [...filterUserList]
                                                const findItem = {...filteredUsers[index]}
                                                findItem['lastName'] = val.target.value
                                                filteredUsers[index] = findItem
                                                setFilterUserList(filteredUsers)
                                              }}
                                            />}
                                          />
                                          <Label className='form-label' for={`newLastName`}>
                                            Last Name
                                          </Label>
                                          {errors.newLastName && <FormFeedback>{errors.newLastName.message}</FormFeedback>}
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col sm='12' md='12' lg='12' xl='12'>
                                      {agentAlreadySelected && (
                                        <div className='mt-1'>
                                          <Select
                                            isMulti={true}
                                            classNamePrefix="select"
                                            options={SourceSystem("options")}
                                            value={item.classId ? Array.isArray(item.classId) ? item.classId.map((id) => SourceSystem(id)) : [SourceSystem(item.classId)] : []}
                                            onChange={(val) => handleSourceSystemChange(index, val)}
                                            className={classnames('react-select', { 'is-invalid': false })}
                                            placeholder={`Select Source System Type`}
                                            styles={selectStyles}
                                            components={{
                                              NoOptionsMessage,
                                              ValueContainer: SourceSystemCustomContainer
                                            }}
                                          />
                                      </div>
                                    )}
                                    </Col>
                                    </Row>
                                    <Row className='d-none'>
                                      <Col sm='12' md='12' lg='12' xl='12'>
                                        <div className='mt-1 input-wrapper company_select'>
                                          <Controller
                                            defaultValue=''
                                            control={control}
                                            id='sourceSystem'
                                            name='sourceSystem'
                                            render={({ field: { onChange } }) => <Select
                                              classNamePrefix="select"
                                              options={SourceSystem("options")}
                                              value={item?.sourceSystem}
                                              isClearable
                                              isDisabled={!disabling}
                                              onChange={(val) => {
                                                onChange(val)
                                                setSourceSystem(val)
                                                setValue("sourceSystem", val)
                                                const filteredUsers = [...filterUserList]
                                                const findItem = {...filteredUsers[index]}
                                                findItem['sourceSystem'] = val
                                                filteredUsers[index] = findItem
                                                setFilterUserList(filteredUsers)
                                                if (val) {
                                                  delete errors.sourceSystem
                                                }
                                              }}
                                              className={classnames('react-select', { 'is-invalid': errors['sourceSystem'] })}
                                              placeholder={`Select Source System`}
                                              styles={selectStyles}
                                              components={{ ValueContainer: CustomValueContainer }}
                                            />}
                                          />
                                          {errors.sourceSystem && <FormFeedback>{errors.sourceSystem.message}</FormFeedback>}
                                        </div>
                                        <div>
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row className='d-none'>
                                        <Col sm='12' md='12' lg='12' xl='12'>
                                          <div className='input-wrapper mt-1'>
                                            <Flatpickr
                                              // ref={fpRef}
                                              ref={el => { 
                                                fpRefs.current[makeKey(item.email, index)] = el 
                                              }}
                                              placeholder=""
                                              value={item?.endDate}
                                              className={`form-control`}
                                              options={{
                                                dateFormat: 'Y-m-d',
                                                minDate: new Date()
                                              }}
                                              onChange={(date, dateString) => {
                                                setEndDate(dateString)
                                                const filteredUsers = [...filterUserList]
                                                const findItem = {...filteredUsers[index]}
                                                findItem['endDate'] = dateString
                                                filteredUsers[index] = findItem
                                                setFilterUserList(filteredUsers)
                                              }}
                                              // id={`endDate`}
                                              // name='endDate'
                                              id={makeKey(item.email, index)}
                                              name={makeKey(item.email, index)}
                                            />
                                            <Label className='form-label input_label' for={`endDate`}>
                                              End Date
                                            </Label>
                                            {item?.endDate ? (
                                              <div onClick={() => {
                                                setEndDate(null)
                                                const filteredUsers = [...filterUserList]
                                                const findItem = {...filteredUsers[index]}
                                                findItem['endDate'] = null
                                                filteredUsers[index] = findItem
                                                setFilterUserList(filteredUsers)
                                              }} className='clear-icon'>
                                                  <X size={16} strokeWidth={3} />
                                              </div>
                                            ) : (
                                              <div onClick={() => {
                                                const key = makeKey(item.email, index)
                                                if (fpRefs.current[key]?.flatpickr) {
                                                  fpRefs.current[key].flatpickr.open()
                                                }
                                              }} className='clear-icon'>
                                                <Calendar size={16} strokeWidth={3} />
                                              </div>
                                            )}
                                          </div>
                                        </Col>
                                    </Row>
                                    {(item.classId && item.classId.length > 0) &&
                                      <div className='d-flex mt-2' style={{ justifyContent: "space-between" }}>
                                        <table className="table table-striped table-bordered">
                                          <thead>
                                            <tr>
                                              <th>Source System</th>
                                              <th>End Date</th>
                                              <th>Action</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {item.classId && item.classId.length > 0 && (item.classId.map((id, idx) => {
                                                const listAgentIdsData = [...filterUserList]
                                                const agentAlreadySelectedData = listAgentIdsData.find((agent) => agent.email === item.email)
                                                const endDates = agentAlreadySelectedData?.endDates ? agentAlreadySelectedData?.endDates : []
                                                const findId = endDates.find(find => find.id === id)
                                                return (
                                                  <tr key={id}>
                                                    <td style={{ fontSize: '14px' }}>{SourceSystem(id)?.label}</td>
                                                    <td>
                                                      <div className='input-wrapper'>
                                                        <Flatpickr
                                                          ref={el => { 
                                                            fpRefs.current[makeKey(item.email, id)] = el 
                                                          }}
                                                          placeholder=""
                                                          value={findId?.endDate}
                                                          className={`form-control`}
                                                          options={{
                                                            dateFormat: 'Y-m-d',
                                                            minDate: 'today'
                                                          }}
                                                          onChange={(dates, dateString) => {
                                                            const listAgentIdsData = [...filterUserList]
                                                            const agentAlreadySelected = listAgentIdsData.find((agent) => agent.email === item.email)
  
                                                            if (agentAlreadySelected) {
                                                              const endDates = agentAlreadySelected?.endDates ? [...agentAlreadySelected.endDates] : []
  
                                                              const index = endDates.findIndex((find) => find.id === id)
  
                                                              if (index >= 0) {
                                                                endDates[index].endDate = dateString || null  // ✅ force update
                                                              } else {
                                                                endDates.push({ id, endDate: dateString || null })
                                                              }
  
                                                              const findAgentIndex = listAgentIdsData.findIndex((agent) => agent.email === item.email)
                                                              if (findAgentIndex >= 0) {
                                                                listAgentIdsData[findAgentIndex].endDates = endDates
                                                              }

                                                              setFilterUserList([...listAgentIdsData]) // ✅ new array to trigger re-render
                                                            }
                                                          }}
                                                          id={makeKey(item.email, id)}
                                                          name={makeKey(item.email, id)}
                                                        />
                                                        <Label className='form-label input_label' for={makeKey(item.email, id)}>
                                                          End Date
                                                        </Label>
                                                        {findId?.endDate ? (
                                                          <div onClick={() => {
                                                            const listAgentIdsData = [...filterUserList]
                                                            const agentAlreadySelected = listAgentIdsData.find((agent) => agent.email === item.email)
                                                            if (agentAlreadySelected) {
                                                              const endDates = agentAlreadySelected?.endDates ? agentAlreadySelected?.endDates : []
                                                              const findId = endDates.findIndex(find => find.id === id)
                                                              if (findId >= 0) {
                                                                endDates[findId].endDate = null
                                                              }
                                                              const findAgentIndex = listAgentIdsData.findIndex((agent) => agent.agentId === item.agentId)
                                                              if (findAgentIndex >= 0) {
                                                                listAgentIdsData[findAgentIndex]['endDates'] = endDates
                                                              }
                                                              setFilterUserList(listAgentIdsData)
                                                            }
                                                          }} className='clear-icons'>
                                                              <X size={16} strokeWidth={3} />
                                                          </div>
                                                        ) : (
                                                          <div onClick={() => {
                                                            const key = makeKey(item.email, id)
                                                            if (fpRefs.current[key]?.flatpickr) {
                                                              fpRefs.current[key].flatpickr.open()
                                                            }
                                                          }} className='clear-icons'>
                                                            <Calendar size={16} strokeWidth={3} />
                                                          </div>
                                                        )}
                                                      </div>
                                                    </td>
                                                    <td>
                                                      <span
                                                        onClick={() => {
                                                          handleSourceSystemDelete(index, id)
                                                          const listAgentIdsData = [...filterUserList]
                                                          const agentAlreadySelected = listAgentIdsData.find((agent) => agent.email === item.email)
                                                          if (agentAlreadySelected) {
                                                            const endDates = agentAlreadySelected?.endDates ? agentAlreadySelected?.endDates : []
                                                            const findId = endDates.findIndex(find => find.id === id)
                                                            if (findId >= 0) {
                                                              endDates[findId].endDate = null
                                                            }
                                                            const findAgentIndex = listAgentIdsData.findIndex((agent) => agent.email === item.email)
                                                            if (findAgentIndex >= 0) {
                                                              listAgentIdsData[findAgentIndex]['endDates'] = endDates
                                                            }
                                                            setFilterUserList(listAgentIdsData)
                                                          }
                                                        }}
                                                        className="cross_mark"
                                                        style={{ fontWeight: "900", cursor: "pointer" }}
                                                      >
                                                        Remove
                                                      </span>
                                                    </td>
                                                  </tr>
                                                ) 
                                              })
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    }
                                    {preExistingData?.length > 0 &&
                                  <div style={{ marginTop: "10px", color: "red", fontSize: "14px" }}>Source System ({preExistingData.map(item => SourceSystem(item.sourceSystemId)?.label).join(', ')}) already exists.</div>
                                  }
                                    </AccordionBody>
                                    </AccordionItem>
                                </Accordion>
                              </div>
                          )
                        })}
                      </div>
                  </Col>
                  </Row>
                  }
                    </> : <> <ComponentSpinner></ComponentSpinner></>
                }

              </ModalBody>

              <ModalFooter className='p-0 d-block' style={{ border: 0, marginTop: '30px' }}>
                <Row>
                  <Col sm='12' md='12' lg='12' xl='12' className='p-0 mt-1'>
                    <div className='model_popup_panel model_popup_submit_btn model_popup_footer_fixed' style={{ justifyContent: 'center', padding: "12px 0px", display: "flex", background: "unset" }}>
                      {mspinnerStatus ? (
                        <Button.Ripple color='primary' disabled={mspinnerStatus}>
                          <Spinner size='sm' />
                          <span className='mx-50'>Loading...</span>
                        </Button.Ripple>
                      ) : (
                        <Fragment>
                          <Button className='me-1 reset_button_view' outline color='secondary' onClick={handleReset}>
                            <RefreshCcw size={14} className='align-middle me-sm-25 me-0' />
                            <span className='align-middle d-sm-inline-block mx-50'>Reset</span>
                          </Button>
                          <Button className='create_submit_btn' type='submit' disabled={!disabling || filterUserList?.length === 0 || AgentValidateError}>
                            <span className='align-middle d-sm-inline-block mx-50'>{'Mapping User'}</span>
                          </Button>
                        </Fragment>
                      )}
                    </div>
                  </Col>
                </Row>
              </ModalFooter>
            </Form></>) : (
            <ComponentSpinner />
          )}
        </Sidebar>
        {(modal || infoModal || actionModal) && <Modal isOpen={modal || infoModal || actionModal} toggle={() => updateNo()} color='primary' className='modal-dialog-centered'>
          <ModalHeader toggle={() => updateNo()}>{infoModal ? "Update Information" : sortedUsers[actionIndex].isUserMapping ? "Remove Mapping" : "Make Mapping"}</ModalHeader>
          <ModalBody className='p-2'>
            <div>{infoModal ? "Are you sure want to update the information ?" : sortedUsers[actionIndex].isUserMapping ? "Are you sure want to remove the mapping?" : "Are you sure want to make the mapping?"}</div>
          </ModalBody>
          {<ModalFooter className='p-0 d-block' style={{ border: 0, marginTop: '30px' }}>
            <div className='model_popup_panel model_popup_submit_btn' style={{ justifyContent: 'center' }}>
              <Button color='secondary' onClick={() => updateNo()} className='me-1 reset_button_view btn-cancel'> Cancel </Button>
              {
                !modalSpinnerStatus ? (
                  <Button color='secondary' onClick={() => updateYes()} className='create_submit_btn' >{infoModal ? "Update" : sortedUsers[actionIndex].isUserMapping ? "Remove" : "Active"}</Button>
                ) : (
                  <Button className='me-1' color='secondary' type='submit'>
                    <Spinner size='sm' />
                    <span className='mx-50'>Loading...</span>
                  </Button>
                )}
            </div>
          </ModalFooter>}

        </Modal>}
        <Col sm='12' md='12' lg='12' xl='12'>
          <h5 className='headers-style mt-1'></h5>
          <span className='headers-style mt-1'>Company Information <span style={{ marginLeft: "-5px" }}>
            {/* {!companyDetailsDisabling && <span className='headers-style mt-3 mx-2' style={{ cursor: "pointer" }} onClick={() => {
                            setCompanyDetailsDisabling(!companyDetailsDisabling)
                        }}>
                            <Edit size={18}></Edit></span>} */}
          </span></span>
        </Col>
        {companyName ? (<>
          <Col sm='12' md='12' lg='4' xl='4'>
            <div className='input-wrapper mt-2'>
              <Controller
                control={control}
                id='companyName'
                name='companyName'
                render={({ field: { onChange } }) => <Input
                  placeholder=''
                  invalid={errors.companyName && true}
                  value={companyName}
                  disabled={true}
                  onChange={(val) => {
                    onChange(val, setCompanyName(val.target.value))
                    if (val.target.value !== companyName) {
                      setIsEdited(true)
                    }
                  }} />}
              />
              <Label className='form-label input_label' for={`companyName`}>
                Company Name<span className='text-danger'>*</span>
              </Label>
              {errors.companyName && <FormFeedback>{errors.companyName.message}</FormFeedback>}
            </div>
          </Col>
          <Col sm='12' md='12' lg='4' xl='4'>
            <div className='input-wrapper mt-2'>
              <Controller

                control={control}
                id=''
                name='companyAgentId'
                render={({ field: { onChange } }) => <Input
                  placeholder=''
                  invalid={errors.companyAgentId && true}
                  value={companyAgentId}
                  disabled={true}
                  onChange={(val) => {
                    onChange(val, setCompanyAgentId(val.target.value))
                    if (val.target.value !== companyAgentId) {
                      setIsEdited(true)
                    }
                  }} />}
              />
              <Label className='form-label input_label' for={`companyAgentId`}>
                Agent ID <span className='text-danger'>*</span>
              </Label>
              {errors.companyAgentId && <FormFeedback>{errors.companyAgentId.message}</FormFeedback>}
            </div>
          </Col>
          {companySFUniqueId && <Col sm='12' md='12' lg='4' xl='4'>
            <div className='input-wrapper mt-2'>
              <Controller
                control={control}
                id='companySFUniqueId'
                name='companySFUniqueId'
                render={({ field: { onChange } }) => <Input
                  placeholder=''
                  invalid={errors.companySFUniqueId && true}
                  value={companySFUniqueId}
                  disabled={true}
                  onChange={(val) => { onChange(val, setCompanySFUniqueId(val.target.value)) }} />}
              />
              <Label className='form-label input_label' for={`companySFUniqueId`}>
                SF UniqueId  <span className='text-danger'>*</span>
              </Label>
            </div>
          </Col>}
          <Col sm='12' md='12' lg='4' xl='4'>
            <div className='input-wrapper mt-2'>
              <Controller
                control={control}
                id='department'
                name='department'
                render={({ field: { onChange } }) => <Input
                  placeholder=''
                  invalid={errors.department && true}
                  value={department}
                  disabled={true}

                  onChange={(val) => {
                    onChange(val, setDepartment(val.target.value))
                    if (val.target.value !== department) {
                      setIsEdited(true)
                    }
                  }} />}
              />
              <Label className='form-label input_label' for={`department`}>
                Department<span className='text-danger'>*</span>
              </Label>
              {errors.department && <FormFeedback>{errors.department.message}</FormFeedback>}
            </div>
          </Col>
          {showImportCompBtn() && (
            <Col sm='12' md='12' lg='4' xl='4' className="mt-2">
              {/* <div className='input-wrapper mt-2 d-flex'>
                                <div>status:</div><div className='mx-1'>{companyIdData?.user?.status || 1}</div>
                            </div> */}
              <div>
                <Select
                  classNamePrefix="select"
                  options={options}
                  value={statusOption}
                  onChange={(val) => {
                    setStatus(val)
                  }}
                  // isDisabled={!companyDetailsDisabling}
                  className={classnames('react-select', { 'is-invalid': errors['country'] })}
                  placeholder={`Select Status`}
                  styles={selectStyles}
                  components={{ ValueContainer: CustomValueContainer }}
                />
              </div>
            </Col>
          )}

          {/* {showImportCompBtn() && (
                        <Col sm='12' md='12' lg='4' xl='4' className="mt-2">
                            {<Select
                                classNamePrefix="select"
                                options={regionalOffices}
                                value={regionalOption}
                                onChange={(val) => {
                                    setRegionalOption(val)
                                }}
                                isClearable
                                className={classnames('react-select')}
                                //   isDisabled={!companyDetailsDisabling}
                                placeholder={`Regional Office`}
                                styles={selectStyles}
                                components={{ ValueContainer: CustomValueContainer }}
                            />}
                        </Col>
                    )} */}
          <Col sm='12' md='12' lg='4' xl='4' className="mt-2 d-none">
            <MultiSelect
              options={regionalOffices ?? []}
              value={regionalOption}
              onChange={(selectedOptions) => {
                setRegionalOption(selectedOptions)
              }}
              menuPortalTarget={document.body}
              isSelectAll={true}
              isClearable
              isMulti

              // isDisabled={!companyDetailsDisabling}
              placeholder={`Select Regional Offices <span class='text-danger'>*</span>`}
              components={{ ValueContainer: CustomValueContainer1 }}
            // menuShouldScrollIntoView={true}
            />
          </Col>
          <Col sm='12' md='12' lg='12' xl='12'>
            <h5 className='headers-style mt-1'></h5>
            <span className='headers-style mt-1'>Regional Offices <span style={{ marginLeft: "-5px" }}>
            </span></span>
          </Col>
          <Col sm='12' md='12' lg='12' xl='12' className="mt-1" >
            <div className='d-flex'>
              {regionalOption.map((entity, index) => {
                return (
                  <div key={`e${index}`} className='me-50'>{entity.label}{(regionalOption.length - 1) !== index ? ',' : ''} </div>
                )
              })}
            </div>
          </Col>

          <Col sm='12' md='12' lg='4' xl='4'>
            {((comparingRegionalIds(companyIdData?.regionalOfficeIds, regionalOption)) || (companyIdData?.companyStatus !== statusOption?.id)) && <div className='model_popup_panel model_popup_submit_btn' style={{ padding: "27px 0px 0px" }}>
              <Button color='secondary' onClick={() => cancel()} className='me-1 reset_button_view btn-cancel' > Cancel </Button>
              {
                spinnerUStatus ? (
                  <Button color='secondary' onClick={() => userUpdateFunction()} className='create_submit_btn' >Update</Button>
                ) : (
                  <Button className='me-1' color='secondary' disabled={!spinnerUStatus}>
                    <Spinner size='sm' />
                    <span className='mx-50'>Loading...</span>
                  </Button>
                )}
            </div>}
          </Col>
        </>
        ) : (<div className='text-center'>
          No records to Display</div>)}

      </Row>
      <Row className="card_style pt-2 pb-2 mt-2 d-none" style={{ margin: "0px 0px" }}>
        <Col sm='12' md='12' lg='12' xl='12'>
          <h5 className='headers-style'>Company Address Information</h5>
        </Col>
        <Col sm='12' md='6' lg='4' xl='4' className="mt-1">
          {<Select
            classNamePrefix="select"
            options={optionAdrress}
            value={addressOption}
            onChange={(val) => {
              setAddressOption(val)
            }}
            className={classnames('react-select', { 'is-invalid': errors['country'] })}
            // isDisabled
            placeholder={`Address Type`}
            styles={selectStyles}
            components={{ ValueContainer: CustomValueContainer }}
          />}
        </Col>
        {<Col sm='12' md='6' lg='4' xl='4' className="mt-1">
          {backupData[0]?.newEntry !== 1 && <Button
            className='btn-next me-1 next_btn_panel'
            color='primary'
            disabled
            style={{ padding: "0.7rem", marginTop: "5px" }}
            size='sm'
            onClick={() => {
              const addingData = [...backupData]
              const dummyData = {
                userAddressId: backupData.length + 1,
                isUserMappingActive: true,
                newEntry: 1,
                userAddress: {
                  addressTypeId: 1,
                  address1: "",
                  address2: "",
                  city: "",
                  state: "",
                  countryId: "",
                  countryName: "",
                  isAddressActive: true
                }
              }
              addingData.unshift(dummyData)
              const newErrorMessage = [...errorMessage]
              newErrorMessage.unshift({ address1: '', address2: "", city: "", state: "", country: "" })
              setErrorMessage(newErrorMessage)
              const bufferSpinnerArray = [...spinnerArray]
              bufferSpinnerArray.unshift(false)
              setSpinnerArray(bufferSpinnerArray)
              setBackupData(addingData)
              setSideBarIndex(0)
              setTimeout(() => {
                setShow(!show)
              }, 300)
            }}
          >
            <Plus size={18} />
            <span className='align-middle ms-25'>Add New</span>
          </Button>}
        </Col>}

        <div className="pb-2 mt-2 px-2 mb-2" style={{ margin: "0px 0px" }}>
          <Row>
            {backupData.map((addressObj, index) => {
              if (addressObj.companyAddress.addressTypeId === addressOption.id) {
                return (
                  <Col sm='12' md='6' lg='4' xl='4' key={index} className="mt-1 mb-1" style={{ padding: "0px 7px" }}>
                    <div className='card_style h-100'>
                      <div className="pt-1 pb-1 px-1" style={{ width: "93%", margin: "auto" }}>
                        <div className='frist_Company_lableview_p1_warpper d-flex'>
                          <div className='company_ct_lable_warpper1_invoice' >
                            <h6 className='p-0 Company_lableview_p1'>Address 1</h6>
                          </div>
                          <div className='company_ct_lable_warpper_invoice' >
                            <h6 className='p-0 Company_lableview_p2'>{addressObj.companyAddress.address1}</h6>
                          </div>
                        </div>

                        <div className='frist_Company_lableview_p1_warpper d-flex'>
                          <div className='company_ct_lable_warpper1_invoice' >
                            <h6 className='p-0 Company_lableview_p1'>Address 2</h6>
                          </div>
                          <div className='company_ct_lable_warpper_invoice' >
                            <h6 className='p-0 Company_lableview_p2'>{addressObj.companyAddress.address2 || '-'}</h6>
                          </div>
                        </div>

                        <div className='frist_Company_lableview_p1_warpper d-flex'>
                          <div className='company_ct_lable_warpper1_invoice' >
                            <h6 className='p-0 Company_lableview_p1'>City</h6>
                          </div>
                          <div className='company_ct_lable_warpper_invoice' >
                            <h6 className='p-0 Company_lableview_p2'>{addressObj.companyAddress.city}</h6>
                          </div>
                        </div>

                        <div className='frist_Company_lableview_p1_warpper d-flex'>
                          <div className='company_ct_lable_warpper1_invoice' >
                            <h6 className='p-0 Company_lableview_p1'>State</h6>
                          </div>
                          <div className='company_ct_lable_warpper_invoice' >
                            <h6 className='p-0 Company_lableview_p2'>{typeof (addressObj?.companyAddress?.state) === "object" ? addressObj?.companyAddress?.state?.label : addressObj?.companyAddress?.state || '-'}</h6>
                          </div>
                        </div>

                        <div className='frist_Company_lableview_p1_warpper d-flex'>
                          <div className='company_ct_lable_warpper1_invoice' >
                            <h6 className='p-0 Company_lableview_p1'>Country</h6>
                          </div>
                          <div className='company_ct_lable_warpper_invoice' >
                            <h6 className='p-0 Company_lableview_p2'>{getCountry(addressObj.companyAddress.countryId).label}</h6>
                          </div>
                        </div>
                        {/* <div className='frist_Company_lableview_p1_warpper d-flex'>
                                                    <div className='company_ct_lable_warpper1_invoice' >
                                                        <h6 className='p-0 Company_lableview_p1'>Status</h6>
                                                    </div>
                                                    <div className='company_ct_lable_warpper_invoice' >
                                                        <h6 className='p-0 Company_lableview_p2'>{addressObj.isUserMappingActive ? 'Active' : 'Inactive'}</h6>
                                                    </div>
                                                </div> */}

                      </div>
                      <div className="d-flex " style={{ justifyContent: "space-between" }}>
                        {<div className='headers-style removeAddress' onClick={() => {
                          setModal(!modal)
                          setSideBarIndex(index)
                        }}>
                          <Trash2 size={18}></Trash2><span className='mx-1'>Remove Address</span></div>}

                        {addressObj.companyAddress.isEdit && <div className='headers-style removeAddress' style={{ color: "#00adc3" }} onClick={() => {
                          updateEdit(index)
                        }}>
                          <Edit size={18}></Edit><span className='mx-1'>Edit Address</span></div>}
                      </div>
                    </div>
                  </Col>
                )
              }
            })}
          </Row>
        </div>
      </Row>
      {
        <Row className="card_style pb-2 mt-2" style={{ margin: "0px 0px", minHeight: "260px" }}>
          <Col sm='12' md='6' lg='6' xl='6' className="mt-1">
          {<div className='sub_header-style' style={{ fontWeight: 500 }}>Company Associated Users List</div>}
          </Col>
          {showImportCompBtn() && (
            <Col sm='12' md='6' lg='6' xl='6' className="mt-1">
              {<Button
                className='btn-next me-1 next_btn_panel'
                color='primary'
                style={{ padding: "0.7rem", marginTop: "5px", float: 'right' }}
                size='sm'
                onClick={() => {
                  setShow(true)
                  handleReset()
                }}
              >
                <Plus size={18} />
                <span className='align-middle ms-25'>Add New Mapping</span>
              </Button>}
            </Col>
          )}
          {/* {<Col sm='12' md='6' lg='8' xl='8' className="mt-1 statusesAlign" >
                        <Input
                            style={{ marginTop: "6px" }}
                            type="checkbox"
                            checked={!userStatus}
                            onChange={handleCheckboxChange}
                        /><span className='mx-1' style={{ fontSize: "14px", color: "#000", fontWeight: 500 }}>All Associated Users</span>
                    </Col>} */}
          <Row className="">
            <Col sm="12" className="mt-1">
              <div style={{ fontSize: "16px", color: "#000", fontWeight: 500 }}>Filter By:</div>
            </Col>

            {/* First Name Filter */}
            <Col sm='6' md='6' lg='3' xl='3' className="form_input_wrapper_bootstrapping">
              <div className='input-wrapper mt-2'>
                <Input
                  type="text"
                  placeholder=""
                  value={filterFirstName}
                  onChange={(e) => setFilterFirstName(e.target.value)}
                />
                <Label className='form-label input_label' for='first-name'>
                  First Name
                </Label>
              </div>
            </Col>

            {/* Last Name Filter */}
            <Col sm='6' md='6' lg='3' xl='3' className="form_input_wrapper_bootstrapping">
              <div className='input-wrapper mt-2'>
                <Input
                  type="text"
                  placeholder=""
                  value={filterLastName}
                  onChange={(e) => setFilterLastName(e.target.value)}
                />
                <Label className='form-label input_label' for='last-name'>
                  Last Name
                </Label>
              </div>
            </Col>

            {/* Email Filter */}
            <Col sm='6' md='6' lg='3' xl='3' className="form_input_wrapper_bootstrapping">
              <div className='input-wrapper mt-2'>
                <Input
                  type="text"
                  placeholder=""
                  value={filterEmail}
                  onChange={(e) => setFilterEmail(e.target.value)}
                />
                <Label className='form-label input_label' for='email'>
                  Email
                </Label>
              </div>
            </Col>

            {/* Source System Filter */}
            <Col sm='6' md='6' lg='3' xl='3' className="mt-2">
              <Select
                classNamePrefix="select"
                options={SourceSystem("options")}
                isClearable
                value={filterSourceSystemId}
                onChange={(val) => setFilterSourceSystemId(val)}
                className={classnames('react-select', { 'is-invalid': false })}
                placeholder="Source System"
                styles={{ /* Add your custom styles if needed */ }}
                components={{ /* Add custom components if needed */ }}
              />
            </Col>

            {/* Status Filter */}
            <Col sm='6' md='6' lg='3' xl='3' className="mt-2">
              <div>
                <Select
                  classNamePrefix="select"
                  options={statusOptions}
                  value={userStatus}
                  onChange={(val) => {
                    setUserStatus(val)
                    if (val) {
                      fetch(val?.id, addressStatus)
                    }
                  }}
                  className={classnames('react-select', { 'is-invalid': errors['country'] })}
                  placeholder={`Select Status`}
                  styles={selectStyles}
                  components={{ ValueContainer: CustomValueContainer }}
                />
              </div>
            </Col>

            {/* Reset Button */}
            <Col sm='6' md='6' lg='9' xl='9' className="mt-2">
              <div className='model_popup_panel model_popup_submit_btn model_popup_footer_fixed' style={{ padding: "12px 0px", display: "flex", background: "unset" }}>
                {(filterFirstName || filterLastName || filterEmail || filterSourceSystemId) && (
                  <Button className='me-1 reset_button_view' outline color='secondary' style={{ paddding: "0px 0px" }} onClick={() => {
                    setFilterEmail("")
                    setFilterFirstName("")
                    setFilterLastName("")
                    setFilterSourceSystemId(null)
                    setEndDate(null)
                  }}>
                    <RefreshCcw size={14} className='align-middle me-sm-25 me-0' />
                    <span className='align-middle d-sm-inline-block mx-50'>Reset</span>
                  </Button>
                )}
              </div>
            </Col>
          </Row>
          <div className='d-flex mt-1' style={{ justifyContent: "space-between" }}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th onClick={() => requestSort('userFirstName')} className="sortable-header">
                    First Name
                    <span className="chevron-icon">
                      {(sortConfig.direction === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />)}
                    </span>
                  </th>
                  <th onClick={() => requestSort('userLastName')} className="sortable-header">
                    Last Name
                    <span className="chevron-icon">
                      {(sortConfig.direction === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />)}
                    </span>
                  </th>
                  <th onClick={() => requestSort('userEmail')} className="sortable-header">
                    Email
                    <span className="chevron-icon">
                      {(sortConfig.direction === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />)}
                    </span>
                  </th>
                  <th onClick={() => requestSort('sourceSystemId')} className="sortable-header">
                    Source System
                    <span className="chevron-icon">
                      {(sortConfig.direction === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />)}
                    </span>
                  </th>
                  <th onClick={() => requestSort('startDate')} className="sortable-header">
                    Start Date
                    <span className="chevron-icon">
                      {(sortConfig.direction === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />)}
                    </span>
                  </th>
                  <th onClick={() => requestSort('endDate')} className="sortable-header">
                    End Date
                    <span className="chevron-icon">
                      {(sortConfig.direction === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />)}
                    </span>
                  </th>
                  <th onClick={() => requestSort('lastModifiedDate')} className="sortable-header">
                    Last Modified Date
                    <span className="chevron-icon">
                      {(sortConfig.direction === 'asc' ? <ChevronUp size={14} /> : <ChevronDown size={14} />)}
                    </span>
                  </th>
                  {filteredUsers?.find((item) => item.isUserMapping === false) && <th>Status</th>}
                  {showImportCompBtn() && (<th>Action</th>)}
                </tr>
              </thead>
              {sortedUsers.length ? (
                <tbody>
                  {sortedUsers.map((company) => (
                    <tr key={company.companyId}>
                      <td onClick={() => navigate(`/user/${company.userId}`)}>{company.userFirstName}</td>
                      <td onClick={() => navigate(`/user/${company.userId}`)}>{company.userLastName}</td>
                      <td onClick={() => navigate(`/user/${company.userId}`)}>{company.userEmail}</td>
                      <td onClick={() => navigate(`/user/${company.userId}`)}>{SourceSystem(company.sourceSystemId).value}</td>
                      <td className='text-center' onClick={() => navigate(`/user/${company.userId}`)}>{company?.startDate ? formattedDateIssueFixed(company?.startDate) : '-'}</td>
                      <td className='text-center' onClick={() => navigate(`/user/${company.userId}`)}>{company?.endDate ? formattedDateIssueFixed(company?.endDate) : '-'}
                      </td>
                      <td onClick={() => navigate(`/user/${company.userId}`)}>
                        {formattedDateIssueFixed(company.lastModifiedDate)}
                      </td>
                      {filteredUsers.find((item) => item.isUserMapping === false) && (
                        <td>{company.isUserMapping ? "Active" : "Inactive"}</td>
                      )}
                      {showImportCompBtn() && (
                        <td>
                          {company.isUserMapping ? (
                            <div className="d-flex" style={{ justifyContent: "space-between" }}>
                              <div className='headers-style removeAddress' style={{ width: "100%", background: "none", boxShadow: "none", fontWeight: 400, fontSize: "14px", padding: "0px", textAlign: "left" }} onClick={() => MakeInActive(company.userId, true, company.sourceSystemId)}>
                                {loadingUserId === company.userId ? (
                                  <div>
                                    <Spinner size='sm' />
                                    <span className='mx-50'>Loading...</span>
                                  </div>
                                ) : (
                                  <div>
                                    <Trash2 size={18} /><span className='mx-1'>Remove</span>
                                  </div>
                                )}
                              </div>
                            </div>
                          ) : (<div>
                            <div className="d-flex" style={{ justifyContent: "space-between" }}>
                              <div className='headers-style removeAddress' style={{ width: "100%", background: "none", boxShadow: "none", fontWeight: 400, fontSize: "14px", padding: "0px", textAlign: "left", color: "#00adc3" }} onClick={() => MakeInActive(company.userId, false, company.sourceSystemId)}>
                                {loadingUserId === company.userId ? (
                                  <div>
                                    <Spinner size='sm' />
                                    <span className='mx-50'>Loading...</span>
                                  </div>
                                ) : (
                                  <div>
                                    <Plus size={18} /><span className='mx-1'>Make Active</span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>)}
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>) : (
                <tbody >
                  <td colSpan={5} style={{ textAlign: "center", fontSize: "14px", color: '#000' }}>
                    No Records to Display
                  </td>
                </tbody>
              )}
            </Table>
          </div>
        </Row>
      }
    </div >) : (
      <ComponentSpinner></ComponentSpinner>
    )
  )

}

export default ActiveCompany
